module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-tablet.846deef4.jpg";